export default "__VITE_ASSET__8f114c18__"